var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
export var EditPlaylistOwnershipError;
(function (EditPlaylistOwnershipError) {
    EditPlaylistOwnershipError["ClientNotSet"] = "client_not_set";
})(EditPlaylistOwnershipError || (EditPlaylistOwnershipError = {}));
var mapErrorKeyToMessage = function (key) {
    var _a;
    if (!key)
        return "";
    return (_a = {}, _a[EditPlaylistOwnershipError.ClientNotSet] = "Выберите клиента", _a)[key];
};
export var usePlaylistOwnershipEdit = function (initialState) {
    var _a = React.useState(initialState), ownership = _a[0], setOwnership = _a[1];
    var setType = function (type) {
        if (type === "public") {
            setOwnership({ clientId: null, type: type });
        }
        else {
            setOwnership(__assign(__assign({}, ownership), { type: type }));
        }
    };
    var setClientId = function (id) {
        setOwnership(__assign(__assign({}, ownership), { clientId: id }));
    };
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var validate = function () {
        var key = null;
        if (ownership.type === "private" && ownership.clientId === null) {
            key = EditPlaylistOwnershipError.ClientNotSet;
        }
        setError(key);
        return key === null;
    };
    return {
        type: { value: ownership.type, set: setType },
        clientId: { value: ownership.clientId, set: setClientId },
        error: { key: error, message: mapErrorKeyToMessage(error) },
        set: setOwnership,
        validate: validate,
    };
};
